var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3008 13.8672C12.8616 14.8162 11.0793 15.3775 9.14938 15.3775C4.3703 15.3775 0.496094 11.9351 0.496094 7.68875C0.496094 3.44237 4.3703 0 9.14938 0C13.9285 0 17.8027 3.44237 17.8027 7.68875C17.8027 9.40266 17.1715 10.9856 16.1045 12.2641C16.1646 12.299 16.2215 12.3398 16.2742 12.3867L22.5671 17.9781C22.98 18.345 22.98 18.9397 22.5671 19.3066L22.2266 19.6092C21.8137 19.976 21.1443 19.976 20.7315 19.6092L14.4386 14.0177C14.386 13.971 14.34 13.9205 14.3008 13.8672ZM16.0723 7.68909C16.0723 11.0862 12.9729 13.8401 9.14963 13.8401C5.32637 13.8401 2.227 11.0862 2.227 7.68909C2.227 4.29198 5.32637 1.53809 9.14963 1.53809C12.9729 1.53809 16.0723 4.29198 16.0723 7.68909Z",
    fill: "#0A313F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.fa630163e7348e08bd65b367042f2ee5.svg";
export { ForwardRef as ReactComponent };